import "@/sentry"; // 🛡️ Doit être la PREMIÈRE ligne — init Sentry avant React
import * as Sentry from "@sentry/react";

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for PWA
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
        updateViaCache: 'none'
      });
      
      console.log('[PWA] Service Worker registered successfully:', registration.scope);

      // Force immediate update check (helps TWA pick up new versions on relaunch)
      try { await registration.update(); } catch (_) {}

      // 🚀 Si un SW en attente est déjà installé (cas typique : maman qui a
      // déjà chargé une session précédente avec une vieille version), on l'active
      // immédiatement. Sans ça, l'app peut rester bloquée plusieurs jours sur
      // une version périmée en TWA Android.
      if (registration.waiting && navigator.serviceWorker.controller) {
        console.log('[PWA] Existing waiting SW found, activating');
        try { registration.waiting.postMessage({ type: 'SKIP_WAITING' }); } catch (_) {}
      }
      
      // Check for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        console.log('[PWA] Service Worker update found');

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('[PWA] New content available — activating immediately');
            // 🚀 Activation AUTOMATIQUE dès qu'une nouvelle version est prête.
            // controllerchange déclenchera ensuite un reload de la page.
            try { newWorker.postMessage({ type: 'SKIP_WAITING' }); } catch (_) {}
          }
        });
      });

      // Quand le nouveau SW prend le contrôle, on recharge la page pour utiliser
      // le nouveau JS bundle (sinon l'ancien bundle continue à tourner).
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        console.log('[PWA] New SW activated, reloading');
        window.location.reload();
      });

      // Périodique : on re-check les updates toutes les 30 min.
      setInterval(() => {
        registration.update().catch(() => {});
      }, 30 * 60 * 1000);

      return registration;
    } catch (error) {
      console.error('[PWA] Service Worker registration failed:', error);
    }
  } else {
    console.log('[PWA] Service Workers not supported');
  }
};

// Register SW when page loads
window.addEventListener('load', registerServiceWorker);

const root = ReactDOM.createRoot(document.getElementById("root"));
// 🛡️ ErrorBoundary Sentry au niveau racine : toute erreur React non gérée
// est envoyée à Sentry + on affiche un fallback gracieux (pas de page blanche).
const SentryFallback = ({ resetError }) => (
  <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif', background: 'linear-gradient(135deg, #FFE5E0, #FFC8D3)' }}>
    <div style={{ fontSize: '3rem' }}>💕</div>
    <h1 style={{ color: '#5C3D36', marginTop: '1rem', fontSize: '1.5rem' }}>Oups, un petit souci...</h1>
    <p style={{ color: '#9D8189', maxWidth: '400px', marginTop: '0.75rem' }}>
      MamaLink a rencontré une erreur. L&apos;équipe est automatiquement prévenue 💌
    </p>
    <button onClick={resetError} style={{ marginTop: '1.5rem', background: '#FFB5A7', color: 'white', border: 'none', padding: '0.75rem 1.5rem', borderRadius: '999px', fontSize: '1rem', cursor: 'pointer' }}>
      Réessayer
    </button>
  </div>
);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={SentryFallback} showDialog={false}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
